<p>child-info works!</p>
